import {useAssessmentApi} from '../api/assessment';
import {useEffect, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import {AnimationLoadingScreen} from '../components/loading/loadingScreen';

const toolToRoutes = {
  // Nuralogix: '/pre-face-scan',
  Nuralogix: '/results',
  DermaDetect: '/skin-condition',
  CoughDetection: '/cough-symptoms',
  Hehealth: '/men-sexual-health',
};

export const continueLogic = async assessment => {
  try {
    const userAssesmentReq = await assessment.getLatestAssessment();
    console.log('userAssesmentReq: ', userAssesmentReq);
    const userAssessmentID = userAssesmentReq.data.id;
    console.log('userAssessmentID: ', userAssessmentID);
    let nextToolReq = await assessment.getNextNeededTool(userAssessmentID);
    console.log('nextToolReq: ', nextToolReq);
    if (nextToolReq.data !== 'Nuralogix') sessionStorage.clear();
    return toolToRoutes[nextToolReq.data] || '/results';
  } catch {
    return '/demographics';
  }
};

/**
 * Component to handle API redirection based on the assessment tool.
 *
 * @returns {JSX.Element} The JSX element for handling API redirection.
 */
export const HandlingAPIToolRedirection = () => {
  const assessment = useAssessmentApi();
  const [responseReturned, setResponseReturned] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      const userAssesmentReq = await assessment.getLatestAssessment();
      if (userAssesmentReq.status !== 200) {
        setResponseReturned(true);
        navigate('/demographics');
        return;
      }
      const userAssessmentID = userAssesmentReq.data.id;
      let nextToolReq = await assessment.getNextNeededTool(userAssessmentID);
      if (nextToolReq.status !== 200) {
        setResponseReturned(true);
        navigate('/demographics');
        return;
      }

      if (nextToolReq.data !== 'Nuralogix') sessionStorage.clear();

      setResponseReturned(true);
      navigate(toolToRoutes[nextToolReq.data] || '/results');
    };
    fetchData();
  }, [assessment, navigate]);

  return <AnimationLoadingScreen />;
};
